<script>
export default {
  name: "MyVideoPlayer",
  props: {
    videoSrc: {
      type: String,
      default: ""
    },
    isFull: {
      type: Boolean,
      default: false
    },
    poster: {
      type: String,
      default: ""
    },
    isAutoPlay: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {
      }
    },
    device: {
      type: String,
      default: "ard"
    }
  },
  emits: ["open-gift"],
  data() {
    return {
      player: null,
      isPlaying: false,
      bigPlayButton: null,
      centerView: null,
      backButton: null,
      giftButton: null,
      duration: 0,
      interval: null,
      playerOptions: {
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        fluid: true,
        poster: this.poster,
        aspectRatio: "16:9",
        playbackRates: [0.5, 1, 1.5, 2],
        sources: [
          {
            type: "video/mp4",
            src: this.videoSrc
          }
        ],
        controls: this.device === 'ios',
        bigPlayButton: false,
        controlBar: {
          pictureInPictureToggle: false,
          children: [
            "playToggle",
            "volumePanel",
            "currentTimeDisplay",
            "progressControl",
            "playbackRateMenuButton",
            "fullscreenToggle"
          ]
        },
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试"
      }
    };
  },
  mounted() {
    window.$bus.$on("pauseShortVideo", this.pause);
    this.init();
  },
  watch: {
    isFull() {
      if(this.device === "ios") {
        this.$refs.playerParent.player.controls(true);
      }
      if (this.isFull) {
        this.$refs.playerParent.player.controls(true);
      } else {
        this.$refs.playerParent.player.controls(false);
      }
      this.setBackButtonStatus(this.isFull);
    },
    isPlaying() {
      if (!this.isPlaying) {
        this.bigPlayButton.style.display = "block";
      } else {
        this.bigPlayButton.style.display = "none";
      }
    }
  },
  methods: {

    onReady() {
      let root = this.$refs.videoPlayerContainer.querySelector("div[id]");
      this.initCoverView(root);
      if(this.device === "ios") {
        this.$refs.playerParent.player.controls(true);
      }
      let controlBar = root.querySelector(".vjs-control-bar");
      this.initControlEvent(controlBar);
    },
    onCanplay() {
      this.duration = this.$refs.playerParent.player.duration();
      console.log("视频总时长：", this.duration);
      if (this.isAutoPlay) {
        this.play();
      }
    },
    onPlay() {
      this.isPlaying = true;
      if(!localStorage.getItem("xxxxtoken")) {
        return;
      }
      if(!this.duration) {
        this.duration = this.$refs.playerParent.player.duration();
        if(!this.duration) {
          console.log("获取视频时长出错，本次不记录播放次数");
          return;
        }
      }
      if(this.interval) {
        return;
      }
      let time = this.duration * 1000 / 2;
      if(time > 30) {
        time = 30 * 1000;
      }
      this.interval = setTimeout(() => {
        this.$axios.$get("shorts/addShortsHistory", {
          params: {
            shorts_id: this.item.id
          }
        });
        this.closeTimeout();
      }, time);
      console.log("play", this.duration);
    },
    onPause() {
      this.isPlaying = false;
      this.closeTimeout();
      console.log("pause", this.duration);
    },
    init() {

    },
    closeTimeout() {
      this.interval && clearTimeout(this.interval);
      this.interval = null;
    },
    initControlEvent(el) {
      if(this.device === "ios") return;
      el.addEventListener("transitionend", (e) => {
        let target = e.target;
        let opacity = parseInt(window.getComputedStyle(target).opacity);
        this.setBackButtonStatus(opacity === 1);
      });
    },
    setBackButtonStatus(status) {
      if(this.device === "ios") return;
      // this.backButton.style.display = "none";
      if(status) {
        this.backButton.style.display = "flex";
        if(this.item.gift_course_id != 0) {
          this.giftButton.style.display = "block";
        }
      }else {
        this.backButton.style.display = "none";
        this.giftButton.style.display = "none";
      }
    },
    initCoverView(root) {
      if(this.device !== "ios") {
        root.insertBefore(this.genderCenterView(root), root.querySelector(".vjs-control-bar"));
      }
      // 添加播放按钮
      root.appendChild(this.genderBigPlayButton());
    },
    genderBigPlayButton() {
      this.bigPlayButton = document.createElement("div");
      this.bigPlayButton.className = "big-play-button";
      this.bigPlayButton.innerHTML = `
        <svg class="icon" height="100%" p-id="22514" t="1727156259632" version="1.1" viewBox="0 0 1024 1024" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M836.526491 434.667753C656.714048 297.440472 476.912443 160.200546 297.101806 22.973265c-64.023142-48.859957-156.302732-3.213259-156.302732 77.331343v823.390784c0 80.544602 92.27959 126.1913 156.302732 77.329537 179.810637-137.227282 359.612242-274.467207 539.424685-411.694488 51.014773-38.93841 51.014773-115.724277 0-154.662688z" fill="#DDDDDDAA" p-id="22515"></path></svg>
      `;
      this.bigPlayButton.onclick = () => {
        this.$refs.playerParent.player.play();
      };
      return this.bigPlayButton;
    },
    genderCenterView(root) {
      this.centerView = document.createElement("div");
      this.centerView.className = "center-view";
      this.centerView.onclick = () => {
        if (this.isPlaying) {
          this.pause();
        } else {
          this.play();
        }
      };
      this.backButton = document.createElement("div");
      this.backButton.className = "back-button";
      this.backButton.innerHTML = `
        <svg t="1730775847156" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7181" width="24" height="24"><path d="M683.480334 939.297259a36.859118 36.859118 0 0 1-25.874613-11.716806L241.170918 512.61025 657.605721 95.443147A36.615018 36.615018 0 1 1 709.354946 146.460072L344.669368 512.61025l364.685578 363.953278A36.859118 36.859118 0 0 1 683.480334 939.297259z" fill="#ffffff" p-id="7182"></path></svg>
        <span>返回</span>
      `;
      this.backButton.onclick = (e) => {
        e.stopPropagation();
        this.exitFullscreen();
      };
      this.centerView.appendChild(this.backButton);

      this.giftButton = document.createElement("div");
      this.giftButton.className = "gift-button";
      if(this.item.gift_course_id == 0) {
        this.giftButton.style.display = "none";
      }
      this.giftButton.innerHTML = `
        <img src="${require('@/assets/img/gift-icon.png')}" />
      `
      this.giftButton.onclick = () => {
        this.exitFullscreen();
        this.$nextTick(() => {
          setTimeout(() => {
            this.$emit("open-gift");
          }, 500)
        })
      }
      this.centerView.appendChild(this.giftButton);
      return this.centerView;
    },
    play() {
      this.$refs.playerParent.player.play();
    },
    pause() {
      this.$refs.playerParent.player.pause();
    },
    fullscreen() {
      this.$refs.playerParent.player.requestFullscreen({ navigationUI: "show" });
    },
    exitFullscreen() {
      this.$refs.playerParent.player.exitFullscreen();
    },
    stop() {
      this.$refs.playerParent.player.stop();
    }
  },
    beforeDestroy() {
    // 销毁播放器实例
    if (this.player) {
      this.player.dispose();
    }
    this.closeTimeout();
    window.$bus.$off("pauseShortVideo", this.pause);
  }
};
</script>

<template>
  <div ref="videoPlayerContainer" class="video-player-container">
    <video-player
      ref="playerParent"
      :options="playerOptions"
      :playsinline="true"
      class="vjs-custom-skin"
      @canplay="onCanplay"
      @pause="onPause"
      @play="onPlay"
      @ready="onReady"
    />
  </div>
</template>

<style scoped>
.video-player-container {
  width: 100%;
}

::v-deep .vjs-big-play-button {
  display: none;
}

::v-deep .big-play-button {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  width: 5rem;
  height: 5rem;
}

::v-deep .center-view {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

::v-deep .center-view .back-button {
  position: absolute;
  left: 1rem;
  top: 2rem;
  display: none;
  align-items: center;
}

::v-deep .center-view .back-button span {
  margin-left: 0.2rem;
  font-size: 0.9rem;
}

::v-deep .center-view svg {
  width: 1.3rem;
  height: 1.3rem;
}

::v-deep .center-view img {
  width: 2rem;
  height: 2rem;
}

::v-deep .center-view .gift-button img {
  animation: jump 1s infinite ease-in-out; /* 应用跳动动画 */
}

::v-deep .center-view .gift-button {
  position: absolute;
  right: 1rem;
  top: 50%;
  display: none;
  align-items: center;
  transform: translateY(-50%);
}

::v-deep .exit-screen-view {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

@keyframes jump {
  0%, 100% {
    transform: translateY(0) rotateZ(0deg);
  }

  25% {
    transform: translateY(-4px) rotateZ(-5deg);
  }

  50% {
    transform: translateY(0) rotateZ(0deg);
  }

  75% {
    transform: translateY(-8px) rotateZ(5deg);
  }
}
</style>
